// eslint-disable-next-line max-classes-per-file
import { userAgent } from '@tink/tink-link-core/src/user-agent-detector';

declare global {
  interface Window {
    NESTED_OAUTH_POPUP: Window | null;
  }
}

export class NestedPopup {
  private NESTED_OAUTH_POPUP: Window | null = null;

  public open(url: string, windowFeatures: string | undefined) {
    this.NESTED_OAUTH_POPUP = window.open(url, 'nested_oauth_popup', windowFeatures);
  }

  public close() {
    if (this.NESTED_OAUTH_POPUP) {
      this.NESTED_OAUTH_POPUP.close();
    }
  }
}

export class StatefulPopup {
  private shouldClose = true;

  private nestedPopup: NestedPopup;

  constructor(nestedPopup: NestedPopup) {
    this.nestedPopup = nestedPopup;
  }

  public disableClosingPopup() {
    this.shouldClose = false;
  }

  public open(url: string, innerHeight = window.innerHeight, innerWidth = window.innerWidth) {
    const windowFeatures = userAgent.isDesktop
      ? `height=${Math.max(innerHeight * 0.9, 450)},width=${Math.max(innerWidth * 0.8, 650)}`
      : undefined;

    this.nestedPopup.open(url, windowFeatures);
  }

  public close() {
    if (this.shouldClose) {
      this.nestedPopup.close();
    }
  }
}

export const nestedPopup = new StatefulPopup(new NestedPopup());
